import DropdownList from "react-widgets/DropdownList";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSubstituterSearchList } from "Api/Common/CommonComponents";

const SubstituterSearch = () => {
    const navigate = useNavigate();

    const {
        data: response,
        error,
        isLoading,
    } = useSubstituterSearchList();
  
    const data =
        response?.data.map((item) => ({
            ...item,
            userName: `${item.vLastName} ${item.vFirstName} ${item.vMiddleName || ""}`
        })) || [];

    const getSubRequests = (id, name) => {
        navigate("/searchsubrequests/" + id, {
            state: { name }
        });
    };

    return (
        <>
            {
                <div >
                    <DropdownList
                        className="dropdown-up"
                        dataKey="iAdminId"
                        textField="userName"
                        placeholder="Zoek op vervanger"
                        data={data}
                        onChange={(nextValue) =>
                            getSubRequests(nextValue.iAdminId, nextValue.userName)
                        }
                    />
                </div>
            }
        </>
    );
};

export default SubstituterSearch;